import React, { FC } from 'react';
import { Button, Container } from 'react-bootstrap';
import LanguageSelect from '../../components/user/language/LanguageSelect';
import { useHistory } from 'react-router';
import { useIntl } from 'react-intl';

const AccountCreatedPage: FC = () => {
  const intl = useIntl();
  const history = useHistory();

  return (
    <>
      <div className="background"></div>

      <Container fluid className="login-container activation-page">
        <div className="login-header">
          <img
            src="https://cache.kreezee.com/home/logos/flat_renverse_logo_kreezee_no_border.svg"
            alt="Kreezee Sports"
          />
          <LanguageSelect color="#fff" />
        </div>
        <Container className="kreezee-login-container py-5">
          <div>
            <div className="message">{intl.formatMessage({ id: 'accountCreatedPage.accountCreatedSuccess' })}</div>
            <Button onClick={() => history.replace('/login')} variant="primary">
              {intl.formatMessage({ id: 'accountCreatedPage.backToLogin' })}
            </Button>
          </div>
        </Container>
      </Container>
    </>
  );
};

export default AccountCreatedPage;
